/* eslint-disable max-len */
/* eslint-disable max-lines */
import {LocaleData} from '../interface';

const lang: LocaleData = {
    title: '如流知识库',
    // adminListTitleForMobile: '管理员',

    commonEnter: '确定',
    commonCancel: '取消',
    commandSave: '保存',
    commandRemove: '移除',

    defaultDocumentTitle: '未命名文档',
    defaultSheetTitle: '未命名表格',
    defaultPPTTitle: '未命名演示文稿',
    defaultDataSheetTitle: '未命名数据表夹',
    defaultDirectoryTitle: '未命名知识本',
    defaultCopyDocumentSuffix: '{title}的复制',

    settingPersonalInfo: '个人设置',
    settingFuntion: '功能设置',
    settingTeamInfo: '知识库信息',
    settingMembers: '成员管理',
    settingModels: '模板管理',
    settingSecurity: '权限设置',
    settingLog: '操作日志',
    settingSuper: '高级设置',
    settingApproval: '审批列表',
    settingAuthRisk: '权限风险',

    buttonCreate: '新建',
    labelHeadCreateDocument: '文档',
    labelHeadCreateSheet: '表格',
    labelHeadCreateDataSheet: '数据表',
    labelHeadCreatePPT: '演示文稿',
    labelHeadCreateDirectory: '知识本',
    labelCreateDocument: '新建文档',
    labelCreateSheet: '新建表格',
    labelCreateDataSheet: '新建数据表',
    labelCreatePPT: '新建演示文稿',
    labelCreateDirectory: '新建知识本',
    labelHeadCreateKnowledge: '知识库',
    labelImportFile: '导入本地文件',
    labelImportPPT: 'PPT',
    labelImportExcel: 'Excel',
    labelImportWord: 'Word',
    labelImportPDF: 'PDF',

    // 知识本二级菜单
    labelChangeKnowledgeType: '切换知识本类型为',
    labelOrdinaryKnowledge: '权限继承知识本',
    labelOpenKnowledge: '公开知识本',
    labelSecrecyKnowledge: '保密知识本',
    labelOrdinaryKnowledgeText: '子页面自动继承知识本权限',
    labelOpenKnowledgeText: '所有子页面，企业内公开',
    labelSecrecyKnowledgeText: '保密知识，知识库成员无权阅读',

    sidebarMenuHome: '主页',
    sidebarMenuMyPersonalHome: '我的主页',
    sidebarMenuPersonalHome: 'TA的主页',
    sidebarNavigation: '导航',
    sidebarMemberManage: '成员',
    sidebarMenuDocumentIndex: '目录',
    sidebarMenuRecycleBin: '回收站',
    sidebarMenuSetting: '设置',
    sidebarMeetingTip: '协作模式中',
    sidebarMenuTag: '标签',
    sidebarBaikeMenuTag: '分类',
    sidebarKuQuestionAnswer: '知识库智能问答',

    commonDoc: '常用页面',
    addCommonDoc: '添加至常用页面',
    removeCommonDoc: '移出常用页面',

    tooltipCreateDoc: '新建文档',
    tooltipCreateSubDoc: '新建子文档',

    indexMenuCopy: '复制',
    indexMenuCopyTo: '复制到',
    indexMenuMove: '移动',
    indexMenuMoveTo: '移动到',
    indexMenuRename: '重命名',
    indexMenuConvertToknowledgeBasis: '变更为知识本',
    indexMenuConvertToDoc: '变更为普通文档',
    indexMenuExport: '导出',
    indexMenuDelete: '删除',
    indexMenuQuickMoveTop: '移动到顶部',
    indexMenuQuickMoveBottom: '移动到底部',


    titleCopyDocument: '复制页面到',
    titleMoveDocument: '移动⻚面到',
    docMoveSearchplaceHolder: '搜索知识库',
    labelMoveDocumentNoRepository: '没有可转移的知识库',

    confirmDeleteDocTitle: '确认删除该页面么？',
    confirmDeleteDirectoryTitle: '确认删除该知识本页面么？',
    confirmDeleteDocInfo: '删除后可在回收站中找到',
    confirmDeleteGainCoinDocInfo: '删除后可在回收站中找到，且此文档获赠的知识币会被回收',
    confirmDeleteDocChildrenInfo: '同时删除页面下所有子页面',
    confirmDeleteDirectoryChildrenInfo: '同时删除知识本页面下所有页面',

    errorCreateDoc: '新建失败',
    errorCreateDocNoAuth: '在此位置无创建权限',
    errorCreateBookNoAuth: '上级文档中已存在知识本，知识本不支持嵌套',
    errorCreateBookAndDocNoAuth: '你无权创建，并且知识本不支持嵌套知识本',
    bookCreateInBookNoAuth: '知识本内不可以创建知识本',
    successRenameDoc: '修改成功',
    errorRenameDoc: '修改失败',
    successDeleteDoc: '删除成功',
    errorDeleteDoc: '删除失败',
    successMoveDoc: '移动成功',
    errorMoveDoc: '移动失败，请稍后重试',
    errorMoveOverBookToBook: '知识本不支持移动到知识本下方',
    errorMoveOverSamePath: '文档不能移动到自身及其子节点下',
    successCopyDoc: '复制成功',
    errorCopyTimeout: '复制超时，后台将继续复制，请稍后刷新页面查看',
    errorCopyDoc: '复制失败，请稍后重试',
    errorMoveNoPermission: '您不是知识库/知识本的管理员或成员，无法移动',
    errorCopyNoPermission: '您不是知识库/知识本的管理员或成员，无法复制', // 403
    errorCopying: '此页面正在被复制中，请稍后再试',
    errorCopyOverMaxCount: '页面及其子页面总数超过400，无法复制',
    errorCopyOverBookToBook: '知识本不支持复制到知识本下方',
    errorCopyOverSamePath: '文档不能保存到自身及其子节点下', // 16004 10401
    errorDeleteBook: '您不是知识库管理员或成员，无法删除',
    successMovetoRight: '移动成功，权限已保留',
    successMovetoRightnoRetain: '移动成功，权限未保留',
    errorMovetoRight: '移动失败',
    errorCopyAndMOveNoRep: '当前知识库不存在或已被删除', // 16000 10303
    errorCopyAndMOveNoPath: '选择的文档路径被删除或移动', // 16001
    errorCopyAndMOveNoDoc: '当前操作文档不存在或已被删除', // 16002
    errorCopyAndMOveSamePath: '相同路径不进行移动', // 16008
    errorCopyAndMOveNoParent: '上一层级文档不存在', // 400
    errorCopyAndMOveNoDepartment: '该知识库存在异常，暂时无法操作', // 10305
    errorCopyAndMOveNoCurDocPermission: '暂无当前文档权限', // 16005
    errorCopyNoChildDocPermission: '子文档无复制权限，请检测后重试', // 16006
    errorCopyNoSelectCurDir: '无法选择当前文档的子目录', // 16007
    errorMoveExternalTypeError: '你所选的部分内容在外部知识库内不支持。仅支持文档、知识本类型。', // 20146
    errorMoveExternalPublicError: '你所选的内容存在部分已在企业内公开，请先关闭企业内公开。', // 20147
    errorCopyExternalTypeError: '你所选的部分内容在外部知识库内不支持。仅支持文档、知识本类型。', // 20144
    errorCopyExternalPublicError: '你所选的内容存在部分已在企业内公开，请先关闭企业内公开。', // 20145

    labelNoMore: '没有更多了',
    adaptiveWidth: '自适应宽度',
    referenceList: '引用列表',
    referenceListTips: '对所有人显示引用列表',
    moveTips: '仅有知识库管理员可使用此功能',
    limitMoveTips: '仅有知识库管理员及页面管理员可使用此功能',
    docNotImpower: '文档内无内链',
    cardViewTitle: '卡片视图',
    openCardView: '已开启卡片视图，对所有人可见',
    closeCardView: '已关闭卡片视图，对所有人可见',

    menuAdaptiveWidth: '自适应宽度',
    showSidebar: '展开侧边栏',
    hideSidebar: '收起侧边栏',

    downloadOriginalFile: '下载原始文件',
    downloadOriginalFileTip: '注意: 下载的为文档导入时的原始文件，',
    fileNotTheLatestTip: '而不是当前最新的文档内容。',
    importDocTimeTip: '原始导入时间：',

    mobileTimeMinuteBefore: '分钟前',
    mobileTimeHoursBefore: '小时前',

    // ------------ az ------------------
    textMember: '团队成员 {count} 人',
    textAddMember: '添加人员',
    textTeamBrief: '简介：',
    textNoNotice: '暂无公告',
    textCreateNotice: '创建公告',
    textNotice: '公告: ',
    labelPageTitle: '页面名称',
    labelUpdatedUser: '更新人',
    labelUpdatedTime: '更新时间',
    labelKnowledgeHomeRecent: '最近更新',
    labelKnowledgeHomeDashboard: '仪表盘',
    textShare: '分享',
    textShareNew: '分享至企业内员工',
    curUserNoRlidTextShare: '需绑定如流后才可以使用分享功能',
    textShareTitle: '指定分享人',
    toastShareSuccess: '分享成功',
    toastShareFailed: '分享失败',
    textToday: '今天',
    textYesterday: '昨天',
    textBeforeYesterday: '前天',
    textPublishNotice: '公告发布',
    textPublish: '发布',
    textPublishNoticeHint: '公告发布后，通知会发送给全部星标了此知识库的用户',
    errorNoticeCanNotNUll: '公告不能为空',
    toastNoticeSuccess: '发布成功',
    toastNoticeFailed: '发布失败',
    textOpenRuLiuApp: '打开如流对话',
    textOrganization: '组织架构',
    labelMembers: '团队成员 {count}',
    labelUnownedStatus: '此知识库当前为无主知识库，',
    labelHowApplyAdmin: '点击查看如何申请管理员',
    labelOperatorUser: '操作人',
    labelOperatorTime: '操作时间',
    toastDeleteTemplateSuccess: '删除成功',
    toastDeleteTemplateFailed: '删除失败',
    labelRepositoryTemplate: '删除知识库模版',
    labelRepositoryDeleteTemplate: '确认删除模板？',
    labelRepositoryTemplateName: '模板名称',
    labelRepositoryTemplateCreateUser: '创建人',
    labelRepositoryTemplateCreated: '创建时间',
    labelUpdateTeamLogo: '更换头像',
    labelTemplateDeleted: '删除',
    textViewedRecentlyRepositories: '最近访问的知识库',
    labelSecurityPersonalDynamics: '个人动态',
    labelSecurityPersonalDynamicsTrends: '其他人无法查看我的个人动态，其他人也不会再收到我的动态通知',
    toastSavingFailedPageSecurity: '设置失败，请重试',
    toastNetworkError: '网络联接异常，请检查网络',

    labelSecurityPageSecurityDisabledInviteReader: '快捷分享',
    labelSecurityPageSecurityDisabledInviteReaderDesc: '（「可阅读」用户可授权他人阅读）',
    labelSecurityPageSecurityDisabledInviteEditor: '快捷编辑',
    labelSecurityPageSecurityDisabledInviteEditorDesc: '（「可编辑」用户可授权他人编辑）',

    labelSecurityPageSecurity: '协同设置',
    labelSecurityDisabledInviteReader: '快捷分享',
    labelSecurityDisabledInviteEditor: '快捷编辑',
    labelSecurityPageSecurityDisabledInviteKuReader: '允许知识库成员邀请知识库只读成员',

    labelSharePageSecurity: '传播设置',
    labelSecurityPageSecurityDisabledCopyRepo: '禁止「可阅读」用户复制内容（仅针对于文档及表格）',
    labelSecurityPageSecurityDisabledDownloadRepo: '禁止「可阅读」用户下载附件（仅文档）',
    labelSecurityPageSecurityDisabledExportRepo: '禁止「可阅读」用户打印/导出 PDF（仅文档）',
    labelSecurityPageSecurityDisabledAIAssistant: '关闭智能知识库助手推荐',

    labelSafePageSecurity: '安全设置',
    labelSecurityPageSecurityAddWaterMark: '开启阅读水印',
    labelSecurityPageSecurityDisabledBrowseRepo: '关闭最近浏览记录',

    labelKnowledgeVisibility: '可见范围',
    labelSecurityPageSecurityOrdinaryKnowledge: '权限继承知识本',
    labelSecurityPageSecurityOrdinaryKnowledgeDesc: '（子页面自动继承知识本权限）',
    labelSeurityPageSecurityOpenKnowledge: '公开知识本',
    labelSeurityPageSecurityOpenKnowledgeDesc: '（公共知识，企业内公开）',
    labelSecurityPageSecuritySecrecyKnowledge: '保密知识本',
    labelSecurityPageSecuritySecrecyKnowledgeDesc: '（保密知识，仅知识本成员有权限）',


    labelSecurityPageSecurityDisabledBrowse: '关闭用户最近浏览详情记录',
    labelSecurityPageSecurityDisabledCopy: '禁止「可阅读」用户复制内容',
    labelSecurityPageSecurityDisabledDownload: '禁止「可阅读」用户下载附件',
    labelSecurityPageSecurityDisabledExport: '禁止「可阅读」用户打印/导出 PDF',

    labelSecurityForceSyncSetting: '强制设置',
    labelSecurityForceSyncSettingDesc: '强制将所有文档的安全设置与知识库进行同步',
    labelSecurityExportSettingDetail: '导出用户设置安全选项详情',
    labelAuxiliaryReading: '知识星链——开启后在文档中划线提示知识点，提供解释和相关链接',
    docReference: '文档引用——开启后显示文档的引用列表',
    recommendReading: '推荐阅读——开启后推荐当前文档的其他相关文档',
    labelSecurityRepository: '权限配置',
    labelSecurityRepositoryDocEdit: '允许知识库成员及页面编辑者，邀请页面的编辑者',
    labelSecurityRepositoryInviteRead: '允许成员邀请知识库只读成员',
    labelSecurityScope: '可见范围',
    labelSecurityScopeNone: '私密（非成员无法查看目录、标题及文档内容）',
    labelSecurityScopeNoneInDep: '私密（非成员无法查看任何内容）',
    labelSecurityScopeReadLimit: '受限（非成员仅可查看目录及标题）',
    labelSecurityScopeRead: '公开',
    pageIsPublic: '页面已公开，企业内所有人可见',
    pageBookIsPublic: '企业内用户均可阅读该知识本内文档',
    publicRepositoryTagInHeaderTips: '企业内用户均可阅读该知识库内文档',
    bookIsPublic: '该知识本不继承知识库成员&只读成员权限',
    toastSavingSuccess: '保存成功',
    toastSavingFailed: '保存失败',
    textNoIntro: '未填写',
    textEmptyIntro: '暂无简介',
    KBIntro: '知识库简介',
    labelHeadLogout: '退出登录',
    labelHomePage: '知识库首页',
    labelPersonalPage: '个人主页',
    labelPersonalRepo: '个人知识库',
    toastUpdateRepositoryNameSuccess: '修改知识库名称成功',
    toastUpdateRepositoryNameFailed: '已存在同名知识库',
    errorRepositoryIntroCanNotBeNull: '简介不能为空',
    errorSaveRepositoryIntroFailed: '简介保存失败',
    labelRoleAdminAndIntro: '管理员：拥有所有权限',
    labelRoleMemberAndIntro: '成员：拥有编辑权限',
    labelRoleReaderAndIntro: '只读成员：仅有阅读权限',
    labelRemoveSelfMemberDelete: '不能移除自己',
    labelNoAuthorityMemberDelete: '没有操作权限',
    labelNoticeRepoMemberDelete: '部门官方公告知识库不支持移除成员',

    // ------------ wzz ------------------
    buttonUnfold: '展开',
    buttonFold: '收起',
    labelMyFollows: '星标知识库',
    textFollowedDocs: '星标页面',
    buttonFollowedMore: '查看更多',
    textViewedDocs: '浏览页面',
    textViewedRepositories: '浏览知识库',
    buttonViewRepository: '个人知识库',
    textDragImageUpload: '可拖动图片到此区域完成上传',
    labelDescription: '知识库简介',
    labelNotice: '公告',
    labelName: '名称',
    labelTags: '标签',
    labelMyself: '自己',
    labelRepositoryLogo: '知识库Logo',
    placeholderRepositoryName: '请输入知识库名称',
    placeholderRepositoryIntro: '介绍一下这个知识库',
    placeholderRepositoryNotice: '这个公告通知需要有二次确认',
    labelRepositoryScope: '可见范围',
    labelNickName: '昵称',
    labelMemberName: '用户名',
    labelAlias: '职责',
    labelEmail: '邮箱',
    labelRole: '角色',
    labelOperator: '操作',
    labelObjectCurrentRepository: '当前空间',
    labelStatusInvited: '已邀请',
    labelRoleAAOwner: '超级管理员',
    labelDepartmentRoleAAOwner: '负责人',
    labelRoleOwner: '所有者',
    labelRoleAdmin: '管理员',
    labeKBlRoleAdmin: '知识库管理员',
    labelRoleMember: '成员',
    labelRoleReader: '只读成员',
    labelRoleDocMember: '可编辑',
    labelRoleDocReader: '可阅读',
    labelRoleDocAdmin: '页面管理员',
    labelRoleAdminIntro: '拥有所有权限',
    labelRoleRepositoryCompileIntro: '拥有知识库编辑权限',
    labelRoleMemberIntro: '拥有内容编辑权限',
    labelRoleReaderIntro: '仅有阅读权限',
    labelRoleDocMemberIntro: '拥有页面编辑权限',
    labelRoleDocReaderIntro: '仅有阅读权限',
    labelRoleDocAdminIntro: '拥有页面管理权限',
    labelRepositoryMembers: '知识库成员（{count}）',
    buttonAddMember: '添加成员',
    labelRemoveMember: '移除成员',
    textRemoveMemberPrompt: '是否确定移除该成员？',
    toastRemoveSuccess: '移除成功',
    toastRemoveFailed: '移除失败',
    toastSettingSuccess: '设置成功',
    toastSettingFailed: '设置失败',
    toastAgreeApply: '已同意申请',
    toastDisagreeApply: '已拒绝申请',
    toastDoc404: '文档不存在或已被删除',
    toastOtherAdminHasOperate: '其他管理员已经进行了操作',
    labelApplyObject: '申请内容',
    labelApplyMemberName: '申请人',
    labelApplyRole: '申请权限',
    labelApplyReason: '申请原因',
    labelApplyTime: '申请时间',
    buttonApprove: '同意',
    buttonRefuse: '拒绝',
    buttonModifyPermission: '修改权限',
    textRefuseApplyPrompt: '确定拒绝该成员加入？',
    placeHolderInputAlias: '请输入职责',

    noPermissionIsAuthorized: '暂无页面访问权限，是否授权查看？',
    authorized: '授权',
    authorizedSuccess: '授权成功',
    authorizedFail: '授权失败',

    // for log
    textGroupNotice: '群公告',
    textRepositoryWithName: '{name}知识库',
    textDocumentWithName: '页面 {name}',
    textUserWithName: '用户{name}',
    textDynamicActionCreate: '创建了',
    textLogActionCreate: '创建了新的',
    textLogActionRetrieve: '查看了',
    textLogActionUpdate: '更新了',
    textLogActionDelete: '删除了',
    textLogActionComment: '评论了',
    textLogActionExport: '导出了',
    textLogActionShare: '分享了',
    textLogActionFollow: '星标了',
    textLogActionLike: '点赞了',
    textLogActionRecovery: '撤销删除了',
    textLogActionCopy: '复制了',
    textLogActionMove: '移动了',
    textLogPermissionApply: '申请成为{objectName}的{roleName}',
    textLogPermissionAgree: '{name}已通过审批成为{objectName}的{roleName}',
    textLogPermissionInvite: '{name}被邀请成为{objectName}的{roleName}',
    textLogPermissionChange: '{name}的权限变为{roleName}',
    textLogPermissionDisagree: '拒绝{name}成为{objectName}的{roleName}',
    textLogDepartmentMoveIn: '将{repositoryName} 移入了部门内',
    textLogDepartmentMoveOut: '将{repositoryName} 移出了部门',
    textLogDepartmentDelete: '删除了 {repositoryName}',
    textLogDepartmentNotice: '更新了群公告',
    textLogDepartmentCreate: '创建了 {repositoryName}',

    // for messages
    textMessage: '通知中心',
    TooltipMentionMessageCount: '有 {count} 条提及消息',
    TooltipApprovalAndOtherMessageCount: '有未读消息',
    TooltipMessageEmpty: '无未读消息',
    labelMessageFollowedRepository: '星标的知识库',
    labelMessageFollowedUser: '星标的用户',
    labelMessageFollowedPage: '星标的页面',
    labelMessageMemberChange: '权限变更',
    labelMessageDepartmentDynamic: '部门动态',
    labelMessageMyRepository: '我的知识库',
    labelMessageCommentReply: '评论回复',
    labelMessageMyAttention: '我关注的文档',
    labelMessageNotice: '备注',
    labelDocAdmin: '页面管理员',
    buttonAgree: '同意',
    buttonReject: '拒绝',
    // 站内通知Tab
    messageTabMention: '@提及',
    messageTabOther: '其他',
    messageTabApproval: '审批',
    // 艾特人
    textMessageMemberMentionMe: '在页面 {{pageName}} 中提及到你',
    textMessageMemberDepMentionMe: '在{{departmentIntro}}里提及到你',
    // 知识库/页面成员权限相关通知
    textMessageMemberInviteMe: '你在{{departmentName}}中知识库 {{repository}} 获得了 {{roleName}} 权限',
    textMessageMemberInviteMeWithOutGroup: '你在知识库 {{repository}} 获得了 {{roleName}} 权限',
    textMessageMemberInviteMeInPage: '你在知识库 {{repository}} 中的页面 {{pageName}} 获得了 {{roleName}} 权限',
    textMessageMemberInviteInMyRepository: '{{operator}} 在我的知识库中邀请了成员 {{member}}，并设置为 {{roleName}}',
    textMessageMemberInviteInMyPage:
        '{{operator}} 在我的知识库中的页面 {{pageName}} 中邀请了成员 {{member}}，并设置为 {{roleName}}',
    //
    textMessageMemberDeleteMe: '你被管理员从{{departmentName}}中知识库 {{repository}} 的成员中移除',
    textMessageMemberDeleteMeWithOutGroup: '你被管理员从知识库 {{repository}} 的成员中移除',
    textMessageMemberDeleteMeInPage: '你被管理员从知识库 {{repository}} 中的页面 {{pageName}} 的成员中移除',
    textMessageMemberDeleteInMyRepository: '{{operator}} 在我的知识库中踢出了成员 {{member}}',
    textMessageMemberDeleteInMyPage: '{{operator}} 在我的知识库中的页面 {{pageName}} 中踢出了成员 {{member}} ',
    //
    textMessageMemberChangeMe: '你在{{departmentName}}知识库 {{repository}} 中的权限从 {{roleName}} 变为 {{nextRoleName}}',
    textMessageMemberChangeMeWithOutGroup: '你在知识库 {{repository}} 中的权限从 {{roleName}} 变为 {{nextRoleName}}',
    textMessageMemberChangeMeInPage:
        '你在知识库 {{repository}} 中的页面 {{pageName}} 权限从 {{roleName}} 变为 {{nextRoleName}}',
    textMessageMemberChangeInMyRepository: '{{operator}} 将我的知识库中 {{member}} 的权限从 {{roleName}} 变为 {{nextRoleName}}',
    textMessageMemberChangeInMyPage:
        '{{operator}} 将我的知识库中的页面 {{pageName}} 中 {{member}} 的权限从 {{roleName}} 变为 {{nextRoleName}}',
    //
    textMessageMemberAgreeInMyRepository: '{{operator}} 在我的知识库中添加了成员 {{member}}，并设置为 {{roleName}}',
    textMessageMemberAgreeInMyPage:
        '{{operator}} 在我的知识库中的 {{pageName}} 中添加了成员 {{member}}，并设置为 {{roleName}}',
    //
    textMessageMemberApply: '申请{{departmentName}}内 知识库 {{repository}} 的 {{roleName}} 权限',
    textMessageMemberApplyWithOutGroup: '申请知识库 {{repository}} 的 {{roleName}} 权限',
    textMessageMemberApplyInPage: '申请知识库 {{repository}} 页面 {{pageName}} 的 {{roleName}} 权限',
    // 知识库相关通知
    textMessageRepositoryDelete: '知识库 {{repository}} 被管理员执行了删除操作，会在 30 个自然日后彻底无法访问',
    textMessageRepositoryWithGroupDelete: '知识库 {{repository}} 被管理员执行了删除操作，管理员可在部门回收站操作恢复',
    textMessageRepositoryUpdate: '知识库 {{repository}} 发布了新的公告',
    // 文档相关通知
    textMessagePageAt: '有人在页面 {{pageName}} 中提到了你',
    textMessagePageCreate: '{{operator}} 在知识库 {{repository}} 中新建了页面 {{pageName}}',
    textMessagePageUpdate: '{{operator}} 在知识库 {{repository}} 中更新了页面 {{pageName}}',
    textMessagePageComment: '{{operator}} 在知识库 {{repository}} 中评论了页面 {{pageName}}',
    textMessagePageLike: '{{operator}} 在知识库 {{repository}} 中点赞了页面 {{pageName}}',
    textMessagePageDelete: '知识库 {{repository}} 中的页面 {{pageName}} 被删除了',
    // 我星标的人相关通知
    textMessageFollowedUserCreatePage: '{{operator}} 在知识库 {{repository}} 中新建了页面 {{pageName}} ',
    textMessageFollowedUserUpdatePage: '{{operator}} 在知识库 {{repository}} 中更新了页面 {{pageName}} ',
    textMessageFollowedUserCreateRepository: '{{operator}} 创建了新的知识库 {{repository}}',
    textMessageFollowedUserLikePage: '{{operator}} 在知识库 {{repository}} 中点赞了页面 {{pageName}}',
    textMessageFollowedUserCommentPage: '{{operator}} 在知识库 {{repository}} 中评论了页面 {{pageName}}',
    // textMessageFollowedUserFollowedUser: '星标了知识库 {{userRepository}} ',
    textMessageFollowedUserFollowedPage: '{{operator}} 星标了知识库 {{repository}} 中的页面 {{pageName}}',
    textMessageFollowedUserFollowedRepository: '{{operator}} 星标了知识库 {{repository}}',
    // 部门成员权限相关通知
    textMessageMemberApplyDepartmentOther: '申请部门名{{departmentName}}的 {{roleName}} 角色权限',
    textMessageMemberInviteDepartmentSelf: '你在 {{departmentName}} 获得了 {{roleName}} 权限。',
    textMessageMemberInviteDepartmentOther: '{{operator}}在{{departmentName}} 中添加了成员 {{member}} ，并设置为 {{roleName}}',
    textMessageMemberDeleteDepartmentSelf: '你被管理员从 {{departmentName}} 的成员中移除。',
    textMessageMemberDeleteDepartmentOther: '{{operator}}在{{departmentName}} 中踢出了成员 {{member}} 。',
    textMessageMemberChangeDepartmentSelf: '你在 {{departmentName}} 中的权限从 {{roleName}} 变为 {{nextRoleName}}',
    textMessageMemberChangeDepartmentOther: '{{member}} 在 {{departmentName}} 中的权限从 {{roleName}} 变为 {{nextRoleName}}',
    // textMessageMemberLeaveDepartmentSelf: '你自行退出了{{departmentName}}',
    textMessageMemberLeaveDepartmentOther: '{{operator}}自行退出了{{departmentName}}',
    // 部门公告更新
    textMessageDepartmentNoticeChange: '{{operator}} 在{{departmentName}} 首页公告中更新了{{DepNoticeTitle}}。',
    // 在部门中删除、新建、移入、移出知识库的相关消息
    textMessageDepartmentDeleteApply: '申请删除{{departmentName}} 中的知识库 {{repository}}',
    textMessageDepartmentDeleteAgree: '{{sender}} 同意了您于{{departmentName}}中删除知识库 {{repository}}的申请。',
    textMessageDepartmentDeleteDisagree: '{{sender}} 拒绝了您于{{departmentName}}中删除知识库 {{repository}}的申请。',
    textMessageDepartmentDelete: '{{operator}}删除了{{departmentName}} 中的知识库{{repository}}。',
    //
    textMessageDepartmentMoveInApply: '申请将知识库{{repository}}移入{{departmentName}}',
    textMessageDepartmentMoveInAgree: '{{sender}} 同意了您将知识库 {{repository}}加入到{{departmentName}}中的申请。',
    textMessageDepartmentMoveInDisagree: '{{sender}} 拒绝了您将知识库 {{repository}}加入到{{departmentName}}中的申请。',
    textMessageDepartmentMoveIn: '{{operator}} 将 知识库{{repository}} 移入了{{departmentName}}',
    //
    textMessageDepartmentMoveOutApply: '申请于{{departmentName}} 中移出知识库 {{repository}}',
    textMessageDepartmentMoveOutAgree: '{{sender}} 同意了您于{{departmentName}}中移出知识库 {{repository}}的申请。',
    textMessageDepartmentMoveOutDisagree: '{{sender}} 拒绝了您于{{departmentName}}中移出知识库 {{repository}}的申请。',
    textMessageDepartmentMoveOut: '{{operator}} 将知识库 {{repository}} 移出了{{departmentName}}',
    //
    textMessageDepartmentCreate: '{{operator}} 在 {{departmentName}} 中新建了知识库 {{repository}} 。',

    // 我关注的文档相关通知
    textMessageMyAttentionPageUpdate: '你关注的页面 {{pageName}} 有了更新。{{clickToView}}',
    textMessageMyAttentionPageAddComment: '你关注的页面 {{pageName}} 中 {{operator}} 添加了评论，{{clickToView}}',
    textMessageMyAttentionPageAddMoreComment: '你关注的页面 {{pageName}} 中添加了多条评论，{{clickToView}}',
    // 评论回复相关通知
    textMessageCommentReply: '{{operator}}在页面 {{pageName}} 回复了你的评论，{{clickToView}}',
    textMessageCommentReplyMore: '你在页面 {{pageName}} 中的多条评论被其他人回复了，{{clickToView}}',
    //
    // for operation log
    textOperationLogRepoUpdateSafe: '修改了知识库安全设置',
    textOperationLogRepoUpdateLogo: '更新了logo',
    textOperationLogRepoUpdateName: '更新了知识库名称，从{{repository}}改为{{nextRepository}}',
    textOperationLogRepoUpdateIntro: '修改了知识库简介',
    textOperationLogRepoUpdateNotice: '发布了公告',
    textOperationLogPageFollow: '星标了{{name}}',
    //
    textOperationLogPageCreate: '创建了页面{{name}}',
    textOperationLogPageRetrieve: '查看了页面{{name}}',
    textOperationLogPageDelete: '删除了页面{{name}}',
    textOperationLogPageUpdate: '编辑了页面{{name}}',
    textOperationLogPageRecovery: '恢复了页面{{name}}',
    textOperationLogPageCopy: '复制页面{{name}}',
    textOperationLogPageMove: '将页面{{name}}从{{repository}}移动到{{toRepository}}',
    textOperationLogPageMoveNew: '将页面{{name}}从{{toRepository}}移动到{{repository}}',
    textOperationLogPageExport: '导出页面{{name}}',
    textOperationLogPageDownload: '下载了{{name}}页面中的附件{{fileName}}',
    textOperationLogPageUnderLineComment: '在页面{{name}}发布了划线评论',
    textOperationLogPageTagChange: '在页面{{name}}设置了标签',
    textOperationLogPageRenameDoc: '页面{{beforeName}}标题修改为{{name}}',
    textOperationLogPageOpenHistorical: '开启了页面{{name}}的历史版本',
    textOperationLogPageCloseHistorical: '关闭了页面{{name}}的历史版本',
    textOperationLogPageDocOpen: '公开了{{docType}}{{name}}',
    textOperationLogPageDocClose: '关闭公开{{docType}}{{name}}',
    textOperationLogPageDocSetAutoClose: '对{{docType}}{{name}}进行了公开时效设置，公开时间为{{hours}}小时',
    textOperationLogPageDocCancelAutoClose: '对{{docType}}{{name}}取消了公开时效的设置',
    textOperationLogPageDocAutoClose: '{{docType}}{{name}}的公开时效到期，已关闭公开',
    textOperationLogPageOpenExcelMentionPeople: '开启了{{name}}的通知设置，在页面中@人后，自动向被提及人发送通知',
    textOperationLogPageClosExcelMentionPeople: '关闭了{{name}}的通知设置，在页面中@人后，不会向被提及人发送通知',
    textOperationLogPageDocForbidReaderCopy: '页面{{name}}开启了禁止只读成员复制内容',
    textOperationLogPageDocCloseForbidReaderCopy: '页面{{name}}关闭了禁止只读成员复制内容',
    textOperationLogPageOpenWaterMark: '页面{{name}}开启了“开启阅读水印”',
    textOperationLogPageCloseWaterMark: '页面{{name}}关闭了“开启阅读水印”',
    textOperationLogPageOpenForbidReaderCopy: '页面{{name}}开启了“禁止只读成员复制内容”',
    textOperationLogPageCloseForbidReaderCopy: '页面{{name}}关闭了“禁止只读成员复制内容”',
    textOperationLogPageOpenForbidReaderDownLoad: '页面{{name}}开启了“禁止只读成员下载附件”',
    textOperationLogPageCloseForbidReaderDownLoad: '页面{{name}}关闭了“禁止只读成员下载附件”',
    textOperationLogPageOpenForbidHelperRecommend: '页面{{name}}开启了“禁止通过智能知识助手推荐”',
    textOperationLogPageCloseForbidHelperRecommend: '页面{{name}}关闭了“禁止通过智能知识助手推荐”',
    textOperationLogPageOpenBrowseRecords: '页面{{name}}开启了“关闭用户最近浏览详情记录”',
    textOperationLogPageCloseBrowseRecords: '页面{{name}}关闭了“关闭用户最近浏览详情记录”',
    textOperationLogPageOpenForbidPrintPdf: '页面{{name}}开启了“禁止只读成员打印/导出PDF”',
    textOperationLogPageCloseForbidPrintPdf: '页面{{name}}关闭了“禁止只读成员打印/导出PDF”',
    textOperationLogPageOpenReaderInviteReader: '页面{{name}}开启了“允许查看者邀请页面查看者”',
    textOperationLogPageCloseReaderInviteReader: '页面{{name}}关闭了“允许查看者邀请页面查看者”',
    textOperationLogPageOpenEditorInviteEditor: '页面{{name}}开启了“允许编辑者邀请页面编辑者”',
    textOperationLogPageCloseEditorInviteEditor: '页面{{name}}关闭了“允许编辑者邀请页面编辑者”',
    textOperationLogPageAutoSetAsAdmin: '被自动设置为自己创建的页面{{name}}的页面管理员',
    textOperationLogPageRemoveBookAuthFromAuthRisk: '{{byOperator}} 在{{docType}} {{name}} 的权限已被移除',

    textOperateLogRepoCreate: '知识库创建',
    textOperateLogRepoDelete: '执行了删除知识库操作',
    textOperateLogRepoRecovery: '撤销了删除知识库操作',
    // 知识库安全设置
    textOperateLogRepoOpenPersonalDynamicState: '打开“个人动态——其他人无法查看我的个人动态，其他人也不会再收到我的动态通知”开关',
    textOperateLogRepoClosePersonalDynamicState: '关闭“个人动态——其他人无法查看我的个人动态，其他人也不会再收到我的动态通知”开关',
    textOperateLogRepoChangeRepositoryPublic: '将可见范围调整为“公开（企业内全员可见）”',
    textOperateLogRepoChangeRepositoryLimited: '将可见范围调整为“受限（非成员仅可查看目录及标题）”',
    textOperateLogRepoChangeRepositoryPrivate: '将可见范围调整为“私密（非成员无法查看目录、标题及文档内容）”',
    textOperateLogRepoOpenWaterMark: '开启了知识库“开启阅读水印”',
    textOperateLogRepoCloseWaterMark: '关闭了知识库“开启阅读水印”',
    textOperateLogRepoOpenForbidReaderCopy: '开启了知识库“禁止只读成员复制内容（仅针对于文档及表格）”',
    textOperateLogRepoCloseForbidReaderCopy: '关闭了知识库“禁止只读成员复制内容（仅针对于文档及表格）”',
    textOperateLogRepoOpenForbidReaderDownLoad: '开启了知识库“禁止只读成员下载附件（仅针对于文档）”',
    textOperateLogRepoCloseForbidReaderDownLoad: '关闭了知识库“禁止只读成员下载附件（仅针对于文档）”',
    textOperateLogRepoOpenForbidHelperRecommend: '开启了知识库“禁止通过智能知识助手推荐”',
    textOperateLogRepoCloseForbidHelperRecommend: '关闭了知识库“禁止通过智能知识助手推荐”',
    textOperateLogRepoOpenBrowseRecords: '开启了知识库“关闭用户最近浏览详情记录（仅针对于文档）”',
    textOperateLogRepoCloseBrowseRecords: '关闭了知识库“关闭用户最近浏览详情记录（仅针对于文档）”',
    textOperateLogRepoOpenForbidPrintPdf: '开启了知识库“禁止只读成员打印/导出PDF（仅针对于文档）”',
    textOperateLogRepoCloseForbidPrintPdf: '关闭了知识库“禁止只读成员打印/导出PDF（仅针对于文档）”',
    textOperateLogRepoOpenReaderInviteReader: '开启了知识库“允许查看者邀请页面查看者”',
    textOperateLogRepoCloseReaderInviteReader: '关闭了知识库“允许查看者邀请页面查看者”',
    textOperateLogRepoOpenEditorInviteEditor: '开启了知识库“允许编辑者邀请页面编辑者”',
    textOperateLogRepoCloseEditorInviteEditor: '关闭了知识库“允许编辑者邀请页面编辑者”',
    textOperateLogRepoOpenMemberInviteReader: '开启了知识库“允许知识库成员邀请知识库只读成员”',
    textOperateLogRepoCloseMemberInviteReader: '关闭了知识库“允许知识库成员邀请知识库只读成员”',
    // 知识库页面权限导出（操作日志）
    textOperateLogRepoExportRepositoryAuthorityPages: '将知识库及页面权限进行导出',
    // 知识库问答功能开启关闭日志
    textOperateLogRepoOpenQACenter: '添加知识库问答功能',
    textOperateLogRepoCloseQACenter: '关闭知识库问答功能',
    // 知识库权限风险一键处理
    textOperateLogRepoRemoveRepoAuthFromAuthRisk: '{{byOperator}} 在知识库的权限已被移除',
    textOperateLogRepoExportPower: '导出了当前知识库及页面的权限',
    // 知识库页面权限导出（站内信中的文案）
    textExportRepositoryAuthorityPagesSuccess: '你的 {{MembersPages}} 知识库权限文件已生成，{{clickExportPages}}',
    textExportRepositoryAuthorityPagesFail: '你的 {{MembersPages}}  知识库权限文件生成失败了',

    //
    textOperationLogMemberInvite: '{{member}}受邀加入{{name}}，权限{{roleName}}',
    textOperationLogMemberApply: '申请加入{{name}}，权限{{roleName}}',
    textOperationLogMemberAgree: '{{member}}审批通过加入{{name}}，权限{{roleName}}',
    textOperationLogMemberDisagree: '拒绝{{member}}加入{{name}}，权限{{roleName}}',
    textOperationLogMemberChange: '{{member}}的{{name}}权限，从{{roleName}}调整为{{nextRoleName}}',
    textOperationLogMemberDelete: '{{member}}被移出知识库',
    textOperationLogDocMemberDelete: '{{member}}被移出{{name}}',
    textOperationLogRemoveMe: '{{member}}在知识库中移除了自己的{{roleName}}权限 ',

    //
    labelDeleteRepository: '删除知识库',
    textDeleteRepositoryDescription:
        '点击下方“删除知识库”按钮来删除整个知识库。但不会立即执行，会在 30 个自然日后删除，期间管理员可以随时撤销。',
    buttonDeleteRepository: '删除知识库',
    textDeleteInDepartRepositoryDescription: '该知识库为部门知识库，点击删除会直接删除进入部门回收站',
    labelConfirmInfo: '确认信息',
    textConfirmDeleteRepository: '您确认删除该知识库吗？',
    buttonRevokeDelete: '撤销删除',
    warningAdminRepositoryWillBeDelete: '此空间将在{deadline}日后删除，期间您可以撤销删除。',
    warningRepositoryWillBeDelete: '此空间将在{deadline}日后删除，若有异议请与管理员联系。',
    textFromRepository: '来自{name}知识库',
    textFromRepositoryForPersonal: '来自{name}',
    labelChooseRepositoryTemplate: '选择知识库模板',
    labelCreateRepositoryInfo: '创建知识库信息',
    buttonNextStep: '下一步',
    buttonBackToReselect: '返回重新选择',
    labelCreateRepositoryName: '知识库名称',
    labelRepositoryReader: '公开',
    labelRepositoryAllReader: '公开（企业内全员可见）',
    labelCreateInDept: '创建至部门知识库',
    createPosition: '创建位置',
    createRepositoryInDepartment: '于部门内创建知识库',
    labelRepositoryReaderLimit: '受限（非成员仅可查看目录及标题）',
    labelRepositoryPrivate: '私密（非成员无法查看任何内容）',
    buttonUploadLogo: '上传头像',
    errorMaxLength: '最多可输入{count}个字符',
    errorNameCanNotBeNull: '名称不能为空',
    errorNameHasExist: '名称已存在',
    errorLogoImageLimit: '图片太大，请选择{limit}M以内的图片',
    toastCreateSuccess: '创建成功',
    toastCreateFailed: '创建失败',
    toastUploadFailed: '上传失败',
    tagMessageHasAgree: '已同意',
    tagMessageHasDisagree: '已拒绝',
    tagMessageHasExpired: '已失效',
    // messagesDraw
    // MARKS: zh-cn-home-SetMessageEntry
    labelMention: '@提及',
    labelRepositoryAt: '其他人在知识库中@我',
    introRepositoryAt: '包括正文@、划线评论@',
    labelDepartmentAt: '其他人在部门中@我',
    labelApproval: '审批',
    labelDongting: '洞听',
    labelShowDongting: '显示洞听调研入口',
    labelRepositoryApprovalOther: '其他用户进行知识库权限申请',
    labelRoleApprovalOther: '其他用户进行部门角色权限申请',
    labelDepartmentApprovalOther: '其他用户进行部门相关操作审批',
    labelOther: '其他',
    labelFocusRepositoryNewStatus: '我所星标的知识库有新的动态',
    introFocusRepositoryNewStatus: '包括：知识库的页面新增、更新、删除，知识库删除与知识库公告更新',
    labelFocusPageNewStatus: '我星标的页面有新的动态',
    introFocusPageNewStatus: '包括：页面发布更新、页面新增评论与删除',
    labelFocusPersonNewStatus: '我星标的人有新的动态',
    introFocusPersonNewStatus: '包括：星标的人创建知识库与页面、点赞与评论、与星标页面或知识库',
    labelChangeRepositoryOther: '其他人在我的知识库中操作',
    introChangeRepositoryOther: '包括：其他人在我的个人知识库新建、更新与删除页面，点赞与评论，知识库用户新增与权限变更',
    labelChangeDepartmentOther: '其他人在我管理的部门中的操作',
    introChangeDepartmentOther: '包括：部门成员新增、删除与退出，知识库移入移出与新建',
    labelChangeDepartmentAnnouncement: '部门公告发生变化',
    labelFocusDepartmentNewStatus: '我星标的部门有新的动态',
    introFocusDepartmentNewStatus: '部门成员与知识库的新增、删除与退出，知识库移入移出与新建',
    labelMyRepositoryPermissionsChange: '我在知识库中的权限变更',
    labelMyDepartmentPermissionsChange: '我在部门中的权限变更',
    labelSmartRecommend: '智能推荐（beta）',
    labelTagReading: '智能标签',
    introTagReading: '可查看和使用智能标签分类和聚合页面',
    labelTwowayLink: '页面引用',
    introTwowayLink: '可查看页面的引用列表',
    labelKnowledgeLink: '知识星链',
    introKnowledgeLink: '可查看页面里的知识点，以及相应的释义和相关链接',
    labelRecommendRead: '相关页面',
    introRecommendRead: '可查看页面的其他相关页面',
    labelTabsTypeMessage: '通知',
    // labelTabsTypeSmartBeta: '智能推荐',
    labelTabsTypeSmartBeta: 'AI智能',
    labelTabsInterfaceDisplay: '界面显示',
    labelMessages: '通知中心',
    labelNoMessage: '暂无通知消息',
    labelNewMessageSeparator: '以下是历史通知',
    labelAiCreate: '智能创作',
    labelUseSpaceKey: '在编辑状态中，使用空格作为快捷键，快速启动智能创作',
    AIAgentSettingItemTitle: '默认开启智能评分',
    AIAgentSettingItemIntro: '智能评分：提供纠错、可读性、职能针对性相关建议',
    AIAgentAutoTitle: '自动进行文档检测',
    AIAgentAutoIntro: '当文档达到评分阈值时，自动进行文档检测，并提供评分和建议',
    OCRSettingItemTitle: '默认开启图片智能分析',
    OCRSettingItemIntro: '图片智能分析：图片解读、文字识别',
    labelTabsTypeOther: '其他',
    labelAutoFollow: '自动关注',
    labelAutoSubscribe: '自动关注自己创建的文档',
    introAutoSubscribe: '文档有版本更新、新增评论、有权限变更时会在如流知识通知服务号通知你，且仅对之后创建的文档生效。',
    labelAutoSubscribeUpdate: '自动关注自己创建的文档的更新',
    labelAutoSubscribeComment: '自动关注自己创建的文档的评论',
    labelAutoSubscribeForward: '自动关注自己创建的文档转发',
    labelAutoSubscribePermission: '自动关注自己创建的文档的权限变更',
    // MARKS: zh-cn-home-SetMessageEntry
    // labelMessageSettings: '通知设置',
    // labelPersonalMessage: '个人通知',
    // labelOthersAtMe: '其他人在知识库中@我',
    // labelMyPermissionChanged: '我在知识库中的权限变更',
    // labelOthersOperationInMyRepository: '其他人在我个人知识库的操作',
    // labelOthersOperationInMyRepositoryIntro:
    //     '包括：新建、更新、评论、点赞、删除页面；调整知识库或者成员权限；添加知识库或页面成员',
    // labelFollowedRepositories: '我星标的知识库',
    // labelFollowedRepositoryPageCreated: '我所星标的知识库中，创建了新页面',
    // labelFollowedRepositoryPageUpdate: '我所星标的知识库中，有页面进行了更新',
    // labelFollowedRepositoryPageDeleted: '我所星标的知识库中，有页面被删除',
    // labelFollowedRepositoryDeleted: '我所星标的知识库被删除',
    // labelFollowedRepositoryNotice: '我所星标的知识库创建了公告',
    // labelFollowedPages: '我星标的页面',
    // labelFollowedPageUpdate: '我所星标的页面有了更新',
    // labelFollowedPageAddComment: '我所星标的页面新增了评论',
    // labelFollowedPageDeleted: '我所星标的页面被删除',
    // labelFollowedUsers: '我星标的人',
    // labelFollowedUserCreatePage: '我所星标的人新建了页面',
    // labelFollowedUserUpdatePage: '我所星标的人更新了页面',
    // labelFollowedUserCreateRepository: '我所星标的人创建了知识库',
    // labelFollowedUserLikedPage: '我所星标的人点赞了页面',
    // labelFollowedUserCommentPage: '我所星标的人评论了页面',
    // labelFollowedUserFollowOthers: '我所星标的人星标了其他人、页面或知识库',
    labelNoData: '暂无数据',
    labelLoadDataError: '加载失败',
    labelPageNotFound: '无法找到页面，此页面不存在或已被删除',
    labelRepositoryNotFound: '无法找到页面，此知识库不存在或已被删除',
    labelPagePersonNotFound: '无法找到页面，此用户已离职或不存在',
    labelEditionNotFound: '无法找到版本，此版本不存在或已被删除',
    labelEditionForbidden: '抱歉，您暂无权限查看知识库页面。如有疑问请咨询您的直属主管',
    buttonClickToRetry: '点击重试',
    labelPageError: '页面跳转异常，请稍后再试',
    labelRefreshErrorPage: '当前页面出错，请刷新页面，或检查页面是否被删除',
    // ------------ xhz ------------------
    textDepartment: '部门：',
    textEmail: '邮箱：',
    textTags: '标签：',
    textNoTags: '暂无标签',
    buttonShare: '分享',
    buttonFollowUser: '星标用户',
    buttonUnFollow: '取消星标',
    buttonFollow: '星标',
    textIntro: '简介：',
    titleMyDynamics: '我的动态',
    titleTADynamics: 'TA的动态',
    textUser: '用户',
    textRepository: '知识库',
    textDoc: '文档',
    buttonAdminList: '查看管理员',
    // textApplyToAdminForMobile: '暂无权限，可向管理员申请权限开通',
    textApplyToAdmin: '暂无权限，您可联系',
    textApplyBelow: '或在下方申请',
    applyAdminList: '申请对象',
    textApply: '申请',
    textAgree: '同意',
    textDisagree: '拒绝',
    labelCurrentRepository: '当前知识库「{name}」',
    labelCurrentBook: '当前知识本「{name}」',
    labelCurrentPage: '当前页面 [{name}]',
    textObjectS: '{name} 的',
    labelApplyAddress: '申请内容',
    labelApplyPermission: '申请权限',
    labelApplyMessage: '备注信息',
    buttonSendApply: '发送申请',
    textHasApplied: '已发送申请，您已向 「{admin}」 申请 {name} 的{role}权限',
    textHasAppliedForModal: '已发送申请',
    textApplyRepositoryPermission: '申请此知识库的',
    buttonCollapse: '收起详细资料',
    buttonExpand: '展开详细资料',
    textRestore: '恢复',
    textShred: '彻底删除',
    titleConfirmInfo: '确认信息',
    textConfirmDeletePage: '您确认要彻底删除此页面吗？',
    textConfirmDeletePages: '您确定要彻底删除这些页面吗？',
    textPageName: '页面名称',
    textMoreTag: '更多标签',
    textOperator: '操作者',
    textDeleteTime: '删除时间',
    textUpdateTime: '更新时间',
    nickname: '更新人',
    textOperation: '操作',
    titleRecycleBin: '回收站',
    btnMassDelete: '删除',
    btnMassRecovery: '恢复',
    textRepositoryQuantifier: '个',
    textUserQuantifier: '名',
    textDocumentQuantifier: '篇',
    textSelectedSomeItems: '已选{count}项',
    textRecycleEmpty: '回收站为空',
    textNoDynamics: '暂无动态',
    labelDocEdit: '可编辑',
    labelDocRead: '可阅读',
    labelDocCheck: '可阅读',
    textNoInput: '未填写',
    textWarnMemberAliasMaxLengthIsTen: '成员职责说明不能超过{maxLength}个字符',
    toastShredSucceed: '彻底删除成功',
    toastShredFailed: '彻底删除失败',
    toastRecoverySucceed: '恢复成功',
    toastRecoveryFailed: '恢复失败',
    toastHasApplied: '申请已同意',
    toastHasApplyMemberUpdate: '申请对象权限已发生变更，请刷新后重试',
    toastApplyFailed: '申请失败',
    toastOperationFail: '操作失败',
    toastOperatorFailAndRetry: '操作失败，请重新尝试',
    buttonUploadCover: '上传封面图片',
    textSelected: '已选 {count} 项',
    textConfirmUnFollowDoc: '您确定不再星标此页面吗？',
    textConfirmUnFollowRepository: '确定取消星标吗？',
    textPageCreatedBySb: '{creator} 创建',
    textPageCreatedBySbWhen: '{creator} 创建于{time}',
    searchPageOrRepoAuthority: '无权限查看此页面',
    searchPageOrRepoKeyWordFromInSide: '搜索内容在正文内，暂无权限查看此页面',
    // ------------------------------

    // ------------ 文档页面 ------------------
    buttonEdit: '编辑',
    buttonPublish: '发布',
    buttonUpdate: '更新',
    buttonStopMeeting: '结束协作',
    endMeetingTip: '关闭协作模式后，所有人均退出协作模式',
    toastStartMeetingSuccess: '协作模式启动成功',
    toastStartMeetingError: '协作模式启动失败, 请重试',
    toastStopMeetingSuccess: '协作模式结束成功',
    toastStopMeetingError: '协作模式结束失败，请稍后重试',
    toastUserStopMeetingNotify: '{{name}}结束了协作模式',
    toastAutoStopMeetingNotify: '协作模式已结束',

    recommendReadingCloseTooltip: '可在个人头像 > 设置 > 智能推荐 > 相关页面 关闭此功能',
    BackPreviewToltip: '退出后内容不会发布，下次进入可继续编辑',
    textUpdateInfo: '{creator}创建于{created}，{updater}最近更新于{time}',
    textFollow: '星标页面',
    textUnFollow: '取消星标页面',
    textFollowTooltip: '星标',
    textUnFollowTooltip: '取消星标',
    menuOperationHistory: '操作记录',
    demonstrationMode: '演示模式',
    cardView: '切换为{viewName}视图',
    menuDocHistory: '历史版本',
    menuSheetHistory: '历史版本',
    seeHistoryVersion: '查看历史版本',
    menuPagePower: '页面权限',
    pageMemberList: '成员管理',
    powerSetting: '权限设置',
    docImpower: '引用文档授权',
    applyPower: '申请权限',
    setHistoryVersion: '开启/关闭历史版本',
    setHistoryVersionTip: '关闭后，仅页面管理员可查看',
    menuDocHistoryTip: '关闭开关后，只有页面管理员可以查看历史版本',
    textConfirmDocHistoryTitle: '确定关闭历史版本吗?',
    textConfirmDocHistory: '关闭后仅⻚面管理员可查看该文档的历史版本。',
    setNoticeOfMentor: '@人发送通知',
    textConfirmNoticeOfMentorTitle: '确定开启表格提及通知吗？',
    textConfirmNoticeOfMentor: '开启后,您在表格中@人,对方将会收到如流通知',
    textConfirmCloseNoticeOfMentorTitle: '确定关闭表格提及通知吗？',
    textConfirmCloseNoticeOfMentor: '关闭后,您在表格中@人,对方将会收不到如流通知',
    saveToHistoryVersion: '另存为自定义版本',
    attentionDocDynamics: '关注文档动态',
    cancelAttentionDocDynamics: '取消文档关注',
    attentionDocDynamicsTooltip: '文档新增评论、有版本更新时会在如流知识通知服务号通知你',
    toastAttentionSuccess: '关注成功，你将在如流服务号收到该文档动态',
    followDocUpdate: '关注文档更新',
    followDocComment: '关注文档评论',
    followDocShare: '关注文档转发',
    followDocPowerChange: '关注文档权限变更',
    unfollowUpdate: '取消关注更新',
    unfollowComment: '取消关注评论',
    unfollowShare: '取消关注转发',
    unfollowPowerChange: '取消关注权限变更',
    followDocUpdateTips: '文档有版本更新时，会在如流「知识通知」服务号通知你',
    followDocCommentTips: '文档有新增评论时，会在如流「知识通知」服务号通知你',
    followDocSharesTips: '文档新增转发时会在如流知识通知服务号通知你',
    followDocPowerChangeTips: '文档有权限变更时，会在如流「知识通知」服务号通知你',
    toastCancelAttentionSuccess: '已取消对该文档动态的关注',
    downloadAllAttachments: '下载全部附件',
    docStats: '字数统计',
    print: '打印/导出PDF',
    printSlideCarryDirectory: '卡片分页（带目录）',
    printSlideNoCarryDirectory: '卡片分页（不带目录）',
    printDocCarryDirectory: '普通视图（带目录）',
    printDocNoCarryDirectory: '普通视图（不带目录）',
    printCarryDirectory: '携带目录',
    printNoCarryDirectory: '不携带目录',
    cardPagination: '卡片分页',
    normal: '普通视图',
    exportExcel: '导出为Excel',
    exportPPT: '导出为PPT',
    menuAddAsTemplate: '添加为模版',
    titleAddAsTemplate: '添加为模版',
    menuPublishToKnowledge: '页面公开',
    menuUnPublishToKnowledge: '撤销页面公开',
    iCafeRelated: '关联至iCafe',
    addICafeCard: '添加iCafe卡片',
    copyShortLink: '复制短链接',
    pageViewSetting: '页面视图设置',
    externalSharing: '对外分享',
    toastPublishToKnowledgeSuccess: '公开成功',
    toastPublishToKnowledgeError: '公开失败',
    toastPublishToKnowledgeErrorMore2000: ' 公开失败，子文档数超过 2000',
    toastPublishError: '发布失败',
    toastPublishSuccess: '发布成功',
    toastUnPublicToKnowledgeSuccess: '已取消公开',
    toastBookCancelPublicSuccess: '已批量取消公开，若知识本下面的子页面有发布到个人主页/广场，会全部撤回',
    toastUnPublicError: '取消公开失败',
    toastUnPublish: '当前文档的最新内容尚未发布，进入编辑页继续编辑或进行发布，发布后的内容在阅读页可见',
    toastClick: '点击',
    titleRemovePermissionTip: '权限收回',
    removePermissionTip: '你的权限被收回, 暂无此页面权限，如需阅读，请申请相关页面权限',
    titleChangePermissionTip: '权限变更',
    changePermissionTip: '你的权限已经发生变更，请刷新后重新进入',
    titleStartMeetingTip: '协作模式',
    deleteMeetingDocTip: '正在协作模式中，无法删除',
    commentsNumber: '总评论数 {number}',
    pageViewNumber: '浏览 {number}',
    noPermissionPrompt: '当前知识库已开启浏览记录，仅管理员和可编辑者可查看浏览记录详情',
    recentBrowseRecordsConfirmDialog: '最近浏览记录',
    // ------------ 文档页面 标签 ------------------
    textDuplicateTagTips: '标签不能重复',
    textMaxTagTips: '标签不可超过{maxLength}个',
    titleCreateTag: '创建标签',
    textEditorNoTags: '无标签',
    toastAddTagError: '添加标签失败',
    toastDeleteTagError: '删除标签失败',
    // ------------ 文档页面 模版选择 ------------------
    toastCreateTemplateError: '模版创建失败',
    titleTemplateName: '模版名称',
    titleEditTemplate: '直接开始编辑，或选择一个模板',
    buttonMoreTemplate: '更多模版',
    titleChooseTemplate: '选择模版',
    titleUserTemplate: '自定义模板',
    titleSystemTemplate: '推荐模版',
    toastTemplateCreated: '模版已添加，可在创建文档时使用',
    toastAllTemplates: '所有模版',
    toastLookUp: '查看',
    // ------------ 部门知识库 ------------------
    download: '下载',
    departmentsetting: '设置',
    departmenthelpcenter: '帮助中心',
    departmentindex: '首页',
    departmentkb: '知识库',
    departmentmembers: '成员',
    departmentstatistics: '统计',
    departmentrecyclebin: '回收站',
    departmentpowerRecycle: '权限风险',
    departmentRole: '角色',
    departmentOperator: '操作',
    departmentAlias: '职责',
    departmentSuperLabelRoleAdmin: '负责人',
    departmentLabelRoleAdmin: '管理员',
    departmentMember: '成员',
    departmentSuperLabelRoleAdminIntro: '拥有组织知识库所有权限',
    departmentLabelRoleAdminIntro: '拥有组织知识库管理权限',
    departmentMemberIntro: '拥有组织知识库查看权限',
    departmentLabelCurrentPage: '当前页面',
    departmentLabelCurrentDepartment: '当前部门 「{name}」',
    departmentCantNotRemoveMember: '无法移除组织架构内成员',
    departmentAddMembers: '添加成员',
    outerDepartment: '部门外',
    outerOrganization: '组织外',
    noMember: '暂无成员',
    member: '成员',
    knowledgeBase: '知识库',
    document: '文档',
    lookUp: '查看全部',
    lookUpDepartmentDetail: '查看部门详情',
    intro: '简介',
    hotKB: '知识库列表',
    outerKB: '外部知识库/部门收藏夹',
    levelWord: '留言板',
    warningDepartmentWillBeDelete: '当前组织已失效，将在{deadline}日后禁止访问，请提前把组织内的知识库移到新的组织。若需要批量移动，请联系 houjunying',

    // ------------- 部门审批列表--------------------
    departmentAAOwner: '负责人',
    departmentAdmin: '管理员',
    // departmentMember: '成员',
    departRoleSuperAdminIntro: '拥有部门及知识库管理权限',
    departRoleAdminIntro: '拥有部门管理权限',
    departRoleMemberIntro: '拥有部门操作权限',
    departmentApplivalObject: '当前部门',
    departmentMoveInKnowledge: '移入知识库',
    departmentMoveOutKnowledge: '移出知识库',
    departmentDeleteKnowledge: '删除知识库',
    departmentApprovalList: '审批列表',
    departmentRejectApproval: '确定拒绝该申请？',
    departmentRejectButton: '拒绝',

    departmentRepositoryMoveInSuccess: '移入成功',
    departmentRepositoryMoveOutSuccess: '移出成功',
    departmentRepositoryDeleteSuccess: '删除成功',
    departmentMemberApprovalSuccess: '已成功加入',
    approvlRefuseSuccess: '拒绝成功',
    departmentOperationFail: '操作失败',

    // ------------- 部门安全设置 ----------------
    departmentSettingSecurityJurisdiction: '负责人拥有所有权限，管理员拥有{markName}相关操作及审批权限；',
    departmentSettingSecurityListAll: '全员可见部门知识库列表',
    departmentSettingSecurityListOne: '仅{markName}内成员可见{markName}知识库列表',
    departmentJurisdiction: '部门权限',
    departmentSettingSuccess: '设置成功',

    // ------------- 部门操作日志 --------------------
    DepartmentNoticeInfo: '部门公告',
    DepartmentIntroduction: '部门简介',
    OrganizationIntroduction: '组织简介',

    DepartmentOperationLogMemberInvite: '{{member}} 被邀请成为{{roleName}}',
    DepartmentOperationLogMemberAgree: '{{member}} 已通过审批成为{{roleName}}',
    DepartmentOperationLogMemberDelete: '{{member}} 被从{{departmentName}}中移除',
    DepartmentOperationLogMemberChange: '{{member}} 的权限从{{roleName}}修改为为{{nextRoleName}}',


    DepartmentRepositoryPull: '将 {{recommend}} 添加为外部知识库/部门收藏夹',
    DepartmentRepositoryMovePull: '将 {{recommend}} 从外部知识库/部门收藏夹中移除',
    DepartmentDeleteLevelWord: '将 留言板中留言进行了删除操作',
    DepartmentUpdateIntroduction: '更新了 {{introduction}}',
    DepartmentNotice: '发布了 {{notice}}',


    DepartmentCreate: '创建了 {{repository}}',
    DepartmentRepositoryMoveIn: '将 {{repository}} 移入{{departmentName}}',
    DepartmentRepositoryMoveOut: '将 {{repository}} 移出{{departmentName}}',

    //
    DepartmentRepositoryUpdateName: '将 {{repository}} 更名为 {{nextRepository}}',
    DepartmentRepositoryDelect: '对 {{repository}} 进行了删除 操作',
    DepartmentRepositoryRevocationDelete: '对 {{repository}} 进行了撤销删除 操作',
    DepartmentRepositoryMoveInRecycleBin: '将 {{repository}} 移入回收站',
    DepartmentRepositoryRestore: '将 {{repository}} 从回收站恢复',

    DepartmentRepositoryUpdateLogo: '更新了 {{markName}}logo',
    DepartmentUpdateSettings: '修改了 {{settings}}',

    // DepartmentRepository

    // --------------部门回收站-------------------
    departmentRecycleBinName: '知识库名称',
    departmentDeleteAll: '你确认要彻底删除这批知识库吗？',
    departmentDeleteOne: '你确认要彻底删除此知识库吗？',
    toastDeleteFailed: '删除失败。',

    // ------------ 简介 ------------------
    departmentIntroduction: '简介',
    departmentIntro: '部门介绍',
    departmentIntroductionEmptyHint: '部门定位、业务介绍、团队概况等，期待你为小伙伴们带来介绍。',
    departmentIntroductionVisitorEmptyHint: '你的部门详情介绍已经在路上，敬请期待。',
    departmentIntroductionDetail: '查看部门详情',

    // ------------ 公告 ------------------
    departmentNotice: '全员公告',
    departmentNoticeCancelTitle: '确定取消吗？',
    departmentNoticeCancelPrompt: '取消后您编辑的页面内容将不会被保存',
    departmentNoticePublishTitle: '确定发布公告吗？',
    errorUploadImageLimit: '上传失败，图片限不超过{limit}M',
    toastPublishAgain: '再次编辑公告，将不再发送消息，仅更新公告的内容',
    toastPublishServiceAndGroup: '发布公告后，通知会同时在"{groupName}群"、「部门消息」服务号发送给部门全员',
    toastPublishService: '发布公告后，通知会通过如流「部门消息」服务号发送给部门全员',
    toastPublishGroup: '发布公告后，通知会通过"{groupName}群"发送给部门全员',
    toastPublish: '此公告不会推送群及服务号消息，公告发布后可在部门公告列表查看',

    // 部门知识库列表
    newRepository: '新建知识库',
    RepositoryName: '知识库名称',
    introduction: '知识库简介',
    createTime: '创建时间',
    updateTime: '更新时间',
    searchRepository: '搜索知识库',
    Administrator: '管理员',
    RepositoryOperation: '操作',
    DocNum: '文档数',
    more: '更多',
    removeDepartment: '移出部门',
    deleteDepartment: '删除',
    isTop: '置顶',
    cancelIsTop: '取消置顶',
    recommendtoDepartmentHome: '推荐至「部门首页」',
    deleteformDepartmentHome: '从「部门首页」移除',
    removeFromRepository: '移出知识库',
    deleteRepository: '删除知识库',
    followed: '已星标',
    addattention: '星标',
    addStar: '添加星标',
    unsubscribe: '取消星标',
    noSearchResult: '无搜索结果',
    loading: '加载中...',
    repositoryInExistence: '该知识库不存在',
    removeInDepartment: '移入部门',
    viewAll: '查看全部',
    applyForAuthority: '权限申请',
    submitApply: '发送申请',

    // 知识库主页
    repositorySuperLabelRoleAdmin: '知识库-管理员',
    repositoryLabelRoleAdmin: '知识库-成员',
    repositoryMember: '知识库-只读成员',
    isLoading: '加载中',
    repoRename: '知识库重命名',
    rename: '重命名',
    exit: '退出',
    nameWarnMaxLength: '名称太长，不能超过{maxLength}个字符',
    noRepository: '暂无知识库',
    // ------------ 主页标签聚合页 -----------
    homeTag: '标签',

    // 引导教学
    gotIt: '知道了',
    gotItTag: '我知道了',
    endMeetingMode: '结束协作',
    endMeetingModeDesc: '结束协作后，所有将恢复到正常模式，更新内容也将实时发布。',
    meetingModeDesc: '适用于以文档开会的用户场景。开启协作模式后：可查看所有在此文档的用户，且任何改动均会实时同步',
    avatarClickDesc: '点击头像，快速定位当前编辑位置',
    tagRecommendDesc: '根据内容为你推荐的标签，可在右上角个人头像->智能推荐里关闭',
    SettingMode: '设置',
    SettingModeDesc: '针对全局性的设置在这里查看，包括通知、智能通知beta',
    rlDocToknowledgeDocDesc: '原如流文档TAB内存量如流文档已迁移至此处，文档TAB内不再存储如流文档。',

    // 全局提示
    // httpsSkipTip: '检测到正在使用https访问知识库，可能造成部分功能无法正常使用。请使用http访问，或者{link}进行切换',

    // 发布到知识广场相关
    pubToKnowledgePerson: '发布到个人主页',
    pubKnowledgeSquareAndPersonSuccess: '已成功发布到个人主页，所有人可见，同时页面会由知识广场推荐给更多人',
    pubKnowledgePersonSuccess: '已成功发布到个人主页，所有人可见',
    pubKnowledgeError: '发布失败，请稍后再试',
    cancelPubPersonSuccess: '取消成功，已从个人主页撤回此页面',
    cancelPubKnowledgeSquareAndPersonSuccess: '取消成功，已从个人主页和知识广场撤回此页面',
    pubKnowledgeSquareFail: '设置失败！请稍后再试',
    pubKnowledgeSquareTitle: '确定发布该页面吗？',
    pubKnowledgeSquareUnPublicText: '页面当前为非公开状态，发布后页面会在您的个人主页显示，所有人可见，页面会被设为公开。',
    pubKnowledgeSquareText: '发布后页面会在您的个人主页显示，所有人可见。',
    cancelPubKnowledgeTitle: '确定取消发布该页面吗？',
    cancelPubKnowledgePersonText: '取消发布后页面会同时从个人主页移除，不会影响页面在知识库的展示',
    cancelPubKnowledgeSquareAndPersonText: '取消发布后页面会同时从个人主页和知识广场移除，不会影响页面在知识库的展示',
    cancelKnowledgeSquareText: '页面当前已被同步至知识广场，撤销公开状态将停止在知识广场的分享。',
    cancelPublishAndPerson: '取消公开成功，且页面已从个人主页撤回',
    cancelPublishAndPersonAndSquare: '取消公开成功，且页面已从个人主页和知识广场撤回',
    watchNow: '立即查看',
    publicButtonText: '公开',
    cancelPublicButtonText: '撤销公开',
    toastPublishToPersonSuccess: '发布成功，并已更新到个人主页。',
    toastPublishToPersonAndSquareSuccess: '发布成功，并已更新到个人主页，知识广场将重新进行审核。',
    confirmDeleteDocPerson: '确认删除页面吗？已同步到个人主页的内容将同步被删除。',
    confirmDeleteDocPersonAndSquare: '确认删除页面吗？已同步到个人主页及知识广场的内容将同步被删除。',
    editStatusFirstEntrySquare: '个人知识库的内容，支持同步到知识广场了！内容发布成功后可在右上角“...”按钮中进行同步操作。',
    squarePreviewPopperTitle: '发布内容，同步到知识广场',
    squarePreviewPopperText: '个人知识库的内容，支持同步到知识广场了！让知识流动起来。',
    squarePreviewPopperBtnText: '知道了',
    ShareCollaborateGuideTitle: '功能融合',
    ShareCollaborateGuideContent: '分享、邀请协作以及页面公开功能融合在一起啦！',
    // 全局提示
    // httpsSkipTip: '检测到正在使用https访问知识库，可能造成部分功能无法正常使用。请使用http访问，或者{link}进行切换',
    publicTips: '文档已公开，请避免文档含有敏感信息',
    bookPublicTips: '知识本公开后，子文档不可单独设置，请前往知识本进行统一设置',
    bookPublicIconTips: '文档已公开，请避免文档内含敏感信息。知识本关闭公开后，子文档同步关闭。',
    bookDocPublicTips: '文档已公开，请避免文档内含敏感信息。知识本子文档公开状态继承知识本，无法单独设置。',
    // 分享协同
    textShareTitleNew: '分享',
    textAddMemberNew: '添加成员',
    toastShareInvitePublishToKnowledgeSuccess: '已切换为公开知识本，默认公开可阅读',
    toastShareInvitePublishToKnowledgeDocSuccess: '文档公开成功',
    textConfirmDocRiskTitle: '重要提示',
    textConfirmDocRisk: '文档公开后，全公司员工均可通过链接访问或者在内网和知识库搜索到该文档，请避免文档内含有敏感信息。',
    textPublicDialogTitle: '公开时效设置',
    textPublicDialog: '设置后，文档将在一定时间后关闭公开',

    // 移入移出提示
    moveInCatalog: '移入知识目录',
    moveInCatalogToast: '移入知识目录将开放权限至知识目录成员',
    moveOutCatalog: '移出知识目录',
    moveOutCatalogToast: '移出知识目录，页面将不再继承知识目录成员权限',
    addDirectoryGuideTitle: '新增知识本',
    addDirectoryIntro: '可对子页面进行便捷的管理，包含：',
    addDirectoryIntroOne: '1、「权限继承」子页面继承当前页面权限',
    addDirectoryIntroTwo: '2、「内容展现」将在当前页面展现子页面目录',

    // 移动失败
    moveError: '移动失败，仅知识库管理员可移动知识本页面及其子页面',
    noEditError: '无当前知识库移动权限',

    // 网络异常警告
    notworkErrorText: '变更失败，请检查网络后重试',

    // 变更失败提示
    convertErrorText: '变更失败',
    toastUnPublishUpdateToKnowledgeSuccess: '修改成功，请避免页面内含有敏感信息',
    toastUnPublishUpdateError: '修改失败',
    helperCenterContactUs: '您有什么问题可以直接在“如流”中搜索“我的如流助手”服务号咨询，或发邮件给我们',
    helperCenterContactUsEmail: '邮件组：so-kldoc@baidu.com',

    docMemberList: '成员列表',
    addMemberSuccess: '添加成员成功',
    addMemberFailed: '添加成员失败',
    addMemberSuccessShareFailed: '添加成员成功，如流会话卡片发送失败',
    // 首页改版
    quickAccess: '快捷访问',
    addToCommonKnowledge: '添加至快捷访问',
    cancelAddToCommonKnowledge: '移出快捷访问',

    // 搜索
    searchInputPlacement: '搜索文档、知识库',
    search: '搜索',
    searchHistory: '搜索历史',
    clearAll: '清空',
    browseHistory: '浏览记录',
    previousPage: '上一页',
    nextPage: '下一页',
    relatedSearch: '相关搜索',
    relatedPerson: '相关人员',
    recentSearch: '最近在搜',
    leaveOfficePersonTooltip: '已离职员工，无相关信息',

    // 新手引导
    declare: '声明',
    declareContent: '欢迎使用知识库，您所在知识库的文档/行为数据，均归属于公司所有，请您知晓。 详情请查看',
    showDeclare: '《关于用户文档/行为数据归属声明》',

    // 激励专项
    toastGiveCoinAlready: '您已对文档赠送过知识币了，去赠送给别人吧~',
    toastGiveCoinNoSelf: '不可以给自己赠送知识币，快去赠送给别人吧~',
    toastGiveCoinError: '赠送失败，请稍后再试',
    giveCoinTips: '知识币是一种荣誉激励，用户可对高价值内容赠送知识币，以表达对创作者的肯定。可兑换知识币是用户个人成就的体现，体现的是他人对自己的认可。快给Ta送个知识币吧~',

    usableCoin: '本周可用知识币',
    ruleDetail: '规则',
    ruleDetailLink: '详细规则',
    usableTips: '本周可用知识币：基于你上周阅读文档次数，系统会自动下发本周可用知识币。若不使用会自动清零 ',
    receivedCoinTip: '文档获赠知识币，是您的高价值文档累计获赠的知识币，可以兑换为简单币。',
    receivedArticleCoinTip: '文档获赠知识币，是您的高价值文档累计获赠的知识币，可以兑换为简单币。',
    receivedActiveCoinTip: '活动奖励知识币，是您积极参加运营活动获得的知识币，可以兑换为简单币。',

    creationRead: '创作与阅读',

    recentDynamic: '动态通知',
    noPermissionForPage: '您没有访问权限',

    coinRule: '知识币介绍',

    // coinWhat: '什么是知识币？',
    coinWhatP1: '1. 知识币是知识库内的知识激励币，用户可对高价值内容赠送知识币，以表达对创作者的高度肯定。',
    coinWhatP2: '2. 可兑换知识币是个人知识创作与知识管理的成就体现。',
    // coinWhatP3: '3. 获得知识币的用户，知识币体现的是大家对自己创作内容的一种高度肯定，是个人的一种成就。',

    coinWhere: '在哪看到我的可兑换知识币？',
    coinWhereP1: '在我的个人主页界面，会显示我的可兑换知识币数量',

    coinHowGet: '如何获得可兑换知识币？',
    coinHowGetP1: '1. 将自己创建的优秀文档公开分享给他人，他人看到并认可文档会赠送知识币',
    coinHowGetP2: '2. 积极参与一些运营活动可获取',

    coinCanDo: '我的可兑换知识币可以送人吗？',
    coinCanDoP1: '我的可兑换知识币，仅作为自己的个人成就，不可将其送于他人。',

    coinHow: '如何获取可用的知识币？',
    coinHowP1: '1. 获取规则',
    coinHowP2: '每周系统自动下发',
    coinHowP3: '当你上周阅读文档次数达{readCount1}次，本周一会下发{coinCount1}个知识币；',
    coinHowP4: '当你上周阅读文档次数达{readCount2}次，本周一会下发{coinCount2}个知识币；',
    coinHowP5: '做任务实时获取',
    coinHowP6: '当天将文档公开发布到个人主页，可立即获得{publishCoinCount}个知识币（每天最多{publishCoinCountMax}次）',
    coinHowP7: '每次送币时，还会随机奖励一些可用知识币',
    coinHowP8: '2. 过期规则',
    coinHowP9: '若当周不使用，当周周日晚24:00自动清零，不能积攒',
    // coinHowP7: '3、使用规则',
    // coinHowP8: '在他人的文档底部可以给文档创建者赠送知识币',

    howToUseCoin: '怎么使用我的可用知识币？',
    howToUseCoinP1: '当你认可他人文档内容时，可在文档底部给文档创建者赠送知识币',
    howToUseCoinP2: '以下几个地方，都会聚合与我相关的文档，可"边逛边送币"',
    howToUseCoinP3: '1. 智能知识助手每天推荐的文档',
    howToUseCoinP4: '2. 他人主页公开发布的文档',
    howToUseCoinP5: '3. 个人主页「去赠币」推荐的文档',

    howExchangeEasyCoin: '知识币怎么兑换成简单币？',
    howExchangeEasyCoinP1: '1. 仅支持「可兑换知识币」兑换简单币，「本周可用知识币」不可兑换',
    howExchangeEasyCoinP2: '2. 可兑换知识币兑换成简单币后，不会扣减实际可兑换知识币的成就数据，仅会扣减可兑换的余额，已兑换过的知识币不能重复兑换',
    howExchangeEasyCoinP3: '3. 你在个人主页点击【兑换简单币】进入兑换界面进行兑换',
    howExchangeEasyCoinP4: '4. 可兑换知识币兑换成简单币后，不会扣减实际 可兑换知识币的成就数据，仅会扣减可兑换的余额，已兑换过的知识币不能重复兑换',
    howExchangeEasyCoinP5: '5.可兑换的知识币有效期为一年，每年6月30日会自动清零一年前未兑换的知识币',

    myDynamicSend: '送你1个知识币',
    myDynamicCollect: '星标了你的⽂档',
    myDynamicLike: '点赞了你的⽂档',
    myDynamicLikeCard: '点赞了你的卡片',
    myDynamicReference: '引⽤了你的⽂档',
    myDynamicVisit: '访问了你的主页',
    getUseCoinLog: '获取&使用记录',
    getCoinLog: '获取记录',
    likeListTitle: '获赞记录',

    dynamicPageColumnContent: '动态内容',
    dynamicPageColumnShare: '文档',
    dynamicPageColumnTime: '时间',
    dynamicPageColumnAllTotal: '全部动态',

    groupDuplicateTip: '此分组已存在',
    publishDialogTitle: '公开并发布我的文档',
    publishDialogSubtitle: '发布后，在个人主页展示，并有可能被推荐给其他人。',
    publishDialogTitleTip: 'tips：通过文档右上⻆三个点里，点击【发布到个人主⻚】，可对指定文档进行发布',
    publishConfirmDialogTitle: '确定公开并发布已选择的文档吗?',
    publishConfirmDialogContent: '发布后⻚面会对所有人公开，且在个人主⻚「我公开发布」列表中显示',
    publishMaxCountToastContent: '最多加载100个文档了，更多文档请到文档页面去发布',

    time: '时间',
    detail: '明细',
    knowledgeCoin: '知识币',
    easyCoin: '简单币',
    gainKnowledgeCoinExchange: '知识币兑换简单币',
    recoverAbnormalGainKnowledgeCoin: '追回异常知识币',
    returnGainKnowledgeCoin: '返还可兑换知识币',
    coinOvertime: '知识币过期回收',
    surplusCanExchangeKnowledgeCoin: '剩余可兑换知识币',
    confirmExchange: '确认兑换',
    limitedTimeRedemption: '一键兑换全部',
    confirmExchangeEasyCoinTitle: '确认兑换成简单币吗？',
    confirmExchangeEasyCoinContent: '您将消耗{knowledgeCoinAmount}个知识币兑换成{exchangeAmount}个简单币，兑换的简单币可在简单小铺使用',
    exchangeSuccess: '兑换成功',
    exchangeFail: '兑换失败，请稍后重试',
    noExchangeLog: '暂无兑换记录',
    exChangeEasyCoinDetailRuleP1: '仅用户「可兑换知识币」可兑换成简单币，「本周可用知识币」不可兑换',
    exChangeEasyCoinDetailRuleP2: '可兑换知识币兑换成简单币后，不会扣减实际可兑换知识币成就数据，仅会扣减可兑换的余额，已兑换过的知识币不能重复兑换',
    exChangeEasyCoinDetailRuleP3: '每个知识币实际可兑换的简单币数量，以界面展示为准',
    exChangeEasyCoinDetailRuleP4: '每人每天最多可兑换{exchangeMaxTime}次，每人每天可兑换知识币上限{exchangeMaxAmount}枚，每人每年可兑换知识币上限{yearlyMaxAmount}枚。每日/每月的兑换总额度有限，当日/当月兑换总额度达到上限时，次日/次月可继续兑换。',
    linitedTimeRedemptionRule: '12月限时放开知识币兑换额度（支持一键兑换所有余额），2025年12月31日结束。每人每天最多可兑换{exchangeMaxTime}次，每人每天可兑换知识币上限{exchangeMaxAmount}枚，每人每年可兑换知识币上限{yearlyMaxAmount}枚。每日/每月的兑换总额度有限，当日/当月兑换总额度达到上限时，次日/次月可继续兑换。',
    exChangeEasyCoinDetailRuleP5: '可兑换的知识币有效期为一年，每年6月30日会自动清零一年前未兑换的知识币',
    exChangeEasyCoinDetailRuleP6: '若发现有作弊行为，会禁用知识币帐号，收回已兑换的简单币。知识币所有解释权归如流知识库所有',
    exchangeEasyCoinNotEnough: '您当前剩余可兑换的知识币不足',
    exchangeEasyCoinDailyLimit: '哎呀，来晚了，今日整体可兑换的简单币的额度已达上限，明日再来兑换吧',
    exchangeEasyCoinYearMaxLeft: '您今年可兑换的金额已达上限，具体可',
    exchangeEasyCoinYearMaxRight: '查看详细规则',
    exchangeEasyCoinTimeUserDailyLimit: '您今天可兑换的次数已达上限，请明日再来兑换',
    exchangeEasyMonthlyLimit: '哎呀，来晚了，本月整体可兑换的简单币的额度已达上限，下个月再来兑换吧',
    exchangeEasyAmountUserDailyLimit: '您今天可兑换的金额已达上限，请明日再来兑换',
    setRepoEntryToSelf: '对他人隐藏「个人知识库」',
    setRepoEntryToAll: '对他人展示「个人知识库」',
    findTabHighQualityDocList: '榜单',
    findTabRecommendDocList: '推荐',
    homeTabPaneText: '首页',
    findTabPaneText: '发现',
    findPageGuideText: '来这里，每天都能发现更多高价值的知识~',

    // 知识广成、知识库个人主页融合
    cancelLikeToastSuccess: '取消点赞成功',
    cancelLikeToastError: '取消点赞失败',

    // 智能问答设置
    QASettingsSuccess: '设置成功',
    QASettingsError: '设置失败',
    QASettingsFallBackIsNull: '兜底回答不能为空',
    QAShareRuLiu: '分享到如流',
    placeHolderQASettings: '请输入你要添加的问题。',
    QACenterOpenCardGuide: '知识库智能问答功能全新上线，开启后即可使用“对话”形式获取知识库内所有知识！',
    QACenterUseCardGuide: '知识库智能问答功能全新上线，快来体验属于你的智能知识助手吧！',
    QACenterTooltip: '该知识库未开启智能问答功能，您可以联系管理员进行开启。',
    qaExportData: '导出用户问答详情',
    qaDataExporting: '已操作导出，导出成功后会通过服务号【知识通知】进行发送',
    qaDataExportError: '导出失败',
    qaWelcomeTitle: '欢迎语',
    qaCustomTitle: '自定义推荐问题',
    qaCustomDescribe: '你可以添加智能问答自定义推荐问题，保存后以下问题将会给所有用户进行默认推荐。',
    qaFinalAnswer: '兜底回答',
    qaFinalAnswerDescribe: '如智能问答无法回答用户的问题，则将会把下方内容返回给用户作为回答',
    placeHolderQaFinalAnswer: '请输入兜底回答。',
    qaInputPlaceholder: '当前知识库内的任何问题都可以直接向我提问。',
    qaCenterFeedbackPlaceholder: '欢迎反馈你在使用过程中遇到的任何问题或建议，感谢你的支持。',
    qaCenterLikeTitle: '赞',
    qaCenterDislikeTitle: '踩',
    qaCenterLikeFeedbackTitle: '对结果满意的原因',
    qaCenterDislikeFeedbackTitle: '对结果不满意的原因',

    // 权限人数提示文案
    purviewMemberCopywriting: '权限已经添加成功，有部分新添加的群或邮件组授权人数会在计算完成后更新',
    repoAndBookMembersAuthRiskRemind: '上周({{timeRange}}) {{members}} 所属组织发生变动，当前知识库及知识本的权限未回收，可能存在权限安全风险，请尽快处理',
    repoPublicRiskRemind: '{{user}} 于{{time}}将知识库设为公开，请避免文档内含有敏感信息，注意知识安全',
    bookPublicRiskRemind: '{{user}} 于{{time}}将知识本 {{doc}} 设为公开，该知识本疑似含敏感信息，请确认是否存在安全风险，若有安全风险建议您取消公开',
    docPublicRiskRemind: '{{user}} 于{{time}}将文档 {{doc}} 设为公开，该文档疑似含敏感信息，请确认是否存在安全风险，若有安全风险建议您取消公开',
    repoPublicRiskRemindNew: '{{user}} 于{{time}}将知识库 {{doc}} 设为公开，有 {{lowerCount}} 个文档检测出敏感信息，请确认是否存在安全风险，若有安全风险建议您：取消公开该知识库',
    bookPublicRiskRemindNew: '{{user}} 于{{time}}将知识本 {{doc}} 设为公开，有 {{lowerCount}} 个文档检测出敏感信息，请确认是否存在安全风险，若有安全风险建议您：取消公开该知识本',
    docPublicRiskRemindNew: '{{user}} 于{{time}}将文档 {{doc}} 设为公开，该文档检测出敏感信息，请确认是否存在安全风险，若有安全风险建议您：取消公开该文档',
    publishDocCancelPublicTips: '已发布的页面不能关闭公开，请先取消发布，再取消公开',
    renewPublicRiskRemind: '{{user}} 于{{time}}更新已公开文档 {{doc}}，该文档检测出敏感信息，请您查看明细确认是否有安全风险，若有安全风险建议您：取消公开该文档',
    cancelPublicRepo: '该知识库 {{objectTitle}} 已公开，包含以下存在敏感信息的文档，若有安全风险建议您修改或取消公开该知识库',
    cancelPublicBook: '该知识本 {{objectTitle}} 已公开，包含以下存在敏感信息的文档，若有安全风险建议您修改或取消公开该知识本',
    cancelPublicDoc: '该文档 {{objectTitle}} 已公开，包含以下存在敏感信息的文档，若有安全风险建议您修改或取消公开该文档',
    // 邀请活动文案
    activeShareRuLiu: '立即邀请新用户',
    activeShareFail: '分享失败，请稍后重试',
    activeShareServerError: '服务异常，请刷新页面后重试',

    docWordCount: '文档字数支持实时显示了',
    batchOperateNewGuide: '批量授权已上线，快来试试吧！',

    // 对外知识库
    externalRepoNoUpdate: '对外知识库暂不支持修改',
    externalRepoNoPublic: '对外知识库暂不支持公开',
};

export default lang;
